/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
    IAgentPlugin,
    IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { LoggerModule } from "@vlinder-web/logger-module-react";
import { VApplication } from "../../../application";
import { REFUND_TRANSACTIONS } from "../graphql/refundTransaction.mutate";

const log: any = LoggerModule?.getInstance();
const getGraphQLModule = () => {
    const app = VApplication.getInstance();
    return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export interface IRefundTransactionMethods extends IPluginMethodMap {
    refundTransaction(args: any): Promise<any>;
}

export class RefundTransactionService implements IAgentPlugin {
    readonly methods: IRefundTransactionMethods;

    constructor() {
        this.methods = {
            refundTransaction: this.refundTransaction.bind(this),
        };
    }

    async refundTransaction(args: any) {
        const graphqlModule = getGraphQLModule();
        const client = graphqlModule.getClient("graphql-gateway");
        console.log("args reinvite==>", args)
        try {
            if (client) {
                const res = await client.mutate({
                    mutation: REFUND_TRANSACTIONS,
                    variables: {
                        txnId: args?.txnId
                    },
                    fetchPolicy: "no-cache",
                });
                if (res?.data) {
                    console.log("res?.data==>", res?.data);
                    return {
                        ...res?.data?.refundTransaction,
                    };
                }
            }
        } catch (err: any) {
            let _display_message =
                err?.graphQLErrors &&
                Array.isArray(err?.graphQLErrors) &&
                err?.graphQLErrors.find((item: any) => item.extensions);
            if (_display_message?.extensions?.display_message) {
                throw Error(_display_message?.extensions?.display_message);
            }

            throw err;
        }
    }
}
